module.exports = {"350725001":"熊山街道","350725101":"东平镇","350725102":"石屯镇","350725103":"铁山镇","350725104":"镇前镇","350725200":"星溪乡","350725201":"外屯乡","350725202":"杨源乡","350725203":"澄源乡","350725204":"岭腰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350725.json
// module id = 1129
// module chunks = 0